import React, { useState, useEffect } from 'react';
import useLangTranslation from '../../../customHooks/languageProvider';
import useFirebase from '../../../../useFirebase';
import { useSelector } from 'react-redux';

const RecentActivity = () => {
    const { selectedDeviceData } = useSelector(({dashboard}) => dashboard);
    const [currentAppStatus, setCurrentAppStatus] = useState(null);
    const { getLangTranslation } = useLangTranslation();
    const { getLastUsedAppDataModel } = useFirebase();

    useEffect(() => {
        async function getLastUsedAppMethod(id) {
            const result = await getLastUsedAppDataModel(id);
            setCurrentAppStatus(result?.currentAppStatus);
        }

        if(selectedDeviceData?.ID) {
            getLastUsedAppMethod(selectedDeviceData?.ID)
        } else {
            setCurrentAppStatus(null);
        }
    },[selectedDeviceData])

    if (currentAppStatus) {
        return (
            <div className="list-item">
                <span className="icon-wrap flex-shrink-0 me-2">
                    <img 
                        src={currentAppStatus?.appIcon} 
                        alt=''
                    />
                </span>
                <div className="flex-grow-1">
                    <p className="text-small text-uppercase light-text mb-1 text-nowrap">{getLangTranslation('CHILD_DETAIL_RECENT_ACTIVITY', 'Recent Activity')}</p>
                    <h5 className="my-0 text-capitalize fs-7">{currentAppStatus?.appName}</h5>
                </div>
            </div>
        )
    } 

    return null;

}

export default RecentActivity